// LiveStreamPusherHandler.js
import { connect } from 'react-redux';

import { JWT_SCOPE_LIVESTREAM_MODERATOR } from '../RemoteConfigKeys.js';

import LiveStreamPusherHandler from '../component/LiveStreamPusherHandler.jsx';
import subscribeStreamChannel from '../action/subscribeStreamChannel.js';
import unsubscribeStreamChannel from '../action/unsubscribeStreamChannel.js';
import {
  subscribePresenceStreamExclusive,
  unsubscribePresenceStreamExclusive,
} from '../action/presenceStreamExclusiveChannelHandler.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getMeData from '../selector/getMeData.js';
import getGoalData from '../selector/getGoalData.js';
import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';

const mapStateToProps = (state, { streamId }) => {
  const meId = getMeData(state, 'id');
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const currentExclusivePrivateId = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'currentId'
  );
  const exclusivePrivateBuyerId = getGoalData(
    state,
    [currentExclusivePrivateId, 'context'],
    'exclusive_to'
  );

  const isLivestreamModerator = getIsPermissionMatched(
    state,
    JWT_SCOPE_LIVESTREAM_MODERATOR
  );
  return {
    meId,
    exclusivePrivateStatus,
    exclusivePrivateBuyerId,
    isLivestreamModerator,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    subscribeStreamChannel: data => dispatch(subscribeStreamChannel(data)),
    unsubscribeStreamChannel: data => dispatch(unsubscribeStreamChannel(data)),
    subscribePresenceStreamExclusive: data =>
      dispatch(subscribePresenceStreamExclusive(data)),
    unsubscribePresenceStreamExclusive: data =>
      dispatch(unsubscribePresenceStreamExclusive(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamPusherHandler);
